import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
// TODO: Import required services for Foreign Keys
// import { ParentService } from '../proxy/general/controllers/parent.service';
// import { SubstituteService } from '../proxy/general/controllers/substitute.service';

FieldBuilder.setNamespace('Controlling');

export const SUBSTITUTEDOCUMENTTYPE_FIELDS: FieldDefinition[] = [
  // TODO: ParentId is a Foreign Key - References Parent entity
  // Uncomment and configure after importing ParentService:
  // FieldBuilder
  //   .foreignKey('parentId', 'Entity.Parent', ParentService)
  //   .required()
  //   .display('name')  // Adjust display field if needed
  //   .keyField('id')   // Adjust key field if needed
  //   .build(),
  // TODO: SubstituteId is a Foreign Key - References Substitute entity
  // Uncomment and configure after importing SubstituteService:
  // FieldBuilder
  //   .foreignKey('substituteId', 'Entity.Substitute', SubstituteService)
  //   .required()
  //   .display('name')  // Adjust display field if needed
  //   .keyField('id')   // Adjust key field if needed
  //   .build(),
];

export const SUBSTITUTEDOCUMENTTYPE_CONFIG = {
  entityName: 'SubstituteDocumentType',
  localizationKey: 'Controlling::Entity.SubstituteDocumentType',
  fields: SUBSTITUTEDOCUMENTTYPE_FIELDS,
  permission: 'General.SubstituteDocumentTypes',
  showInMenu: false,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
